import i18n from "../../i18n/i18n"

export enum EducationalCourseType {
    NotSet = 0,
    ContinuingEducation = 1,
    BasicBus = 2,
    BasicGoods = 3,
    IntensiveBus = 4,
    IntensiveGoods = 5,
    BasicEducation = 6,
    BasicEducationForSta = 7,
    ContinuingEducationForSta = 8,
    SpecialCourseForCub = 9
}

// tslint:disable-next-line:no-namespace
export namespace EducationalCourseType {
	export function displayName(type: EducationalCourseType) {
		const values: { [index: number]: string } = {
			1: "ENUM_EDUCATIONALCOURSETYPE_CONTINUINGEDUCATION",
			2: "ENUM_EDUCATIONALCOURSETYPE_BASICBUS",
			3: "ENUM_EDUCATIONALCOURSETYPE_BASICGOODS",
			4: "ENUM_EDUCATIONALCOURSETYPE_INTENSIVEBUS",
			5: "ENUM_EDUCATIONALCOURSETYPE_INTENSIVEGOODS",
			6: "ENUM_EDUCATIONALCOURSETYPE_BASICEDUCATION",
			7: "ENUM_EDUCATIONALCOURSETYPE_BASICEDUCATIONFORSTA",
			8: "ENUM_EDUCATIONALCOURSETYPE_CONTINUINGEDUCATIONFORSTA",
			9: "ENUM_EDUCATIONALCOURSETYPE_SPECIALCOURSEFORCUB"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(EducationalCourseType[type])
		}
	}
}
